module.exports = __webpack_public_path__ + "img/car.6f24c7c3.png";